import React from 'react';
import { pdf } from '@react-pdf/renderer';
import { AnalyticsSummary, QRCodeData } from '../types';
import { QrReportDocument } from './QrReportDocument';

interface ExportOptions {
  qrCode: QRCodeData;
  analytics: AnalyticsSummary | undefined;
}

export async function exportToPdf({ qrCode, analytics }: ExportOptions): Promise<void> {
  if (!analytics) {
    console.warn('No analytics data to export');
    return;
  }

  const reportElement = React.createElement(QrReportDocument, { qrCode, analytics }) as React.ReactElement<any>;
  const blob = await pdf(reportElement).toBlob();

  const filename = `${qrCode.title.replace(/[^a-zA-Z0-9]/g, '_')}_report_${new Date().toISOString().split('T')[0]}.pdf`;

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
